module.exports = __webpack_public_path__ + "images/signal_5.1dde047104424734a1c32518bf9e118b.png";